import React from 'react';
import FAIcon from '../../FAIcon/FAIcon';


const ActiveCell = ({ value }) =>
	(value && <FAIcon className="text-success" name="check" alt="true" />) || null;

export default ActiveCell;
